import anonymousClient from '../../../shared/apicllient/AnonymousClient'
import * as types from '../../types'
import { encryptPassword } from '../../../shared/apicllient/PasswordService'
import router from '../../../router'

const loginUrl = '/user/authenticate'

export default {
    state: {
        loggedIn: false,
        userName: '',
        token: '',
        roles: '',
    },
    getters: {
        [types.GET_AUTH_LOGGEDIN]: state => state.loggedIn,
        [types.GET_AUTH_USERNAME]: state => state.userName,
        [types.GET_AUTH_TOKEN]: state => state.token,
        [types.GET_AUTH_ROLE]: state => state.roles,
    },
    mutations: {
        [types.MUTATE_AUTH_LOGIN]: (state, userData) => {
            state.token = userData.token
            state.userName = userData.userName
            state.roles = userData.role
            state.loggedIn = userData.hasLoggedIn
            localStorage.setItem('token', userData.token)
        },
    },
    actions: {
        [types.ACTION_AUTH_LOGIN]: ({ commit }, authorizationData) => {
             anonymousClient.post(process.env.VUE_APP_API + loginUrl, {
                username: authorizationData.userName,
                password: encryptPassword(authorizationData.password),
            }).then(response => {
                commit(types.MUTATE_AUTH_LOGIN, {
                    userName: response.data.username,
                    token: response.data.token,
                    roles: response.data.role,
                    hasLoggedIn: true,
                })
                router.push('/dashboard')
            }).catch(error => {
                console.log(error)
            })
        },
    },

}
